import { render } from "./Editbox.vue?vue&type=template&id=4f4d13e9&scoped=true"
import script from "./Editbox.vue?vue&type=script&lang=js"
export * from "./Editbox.vue?vue&type=script&lang=js"

import "./Editbox.vue?vue&type=style&index=0&id=4f4d13e9&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4f4d13e9"

export default script